import React from 'react';
import PropTypes from 'prop-types';

import HistoryControls from 'components/HistoryControls';
import NewQuestionButton from 'components/NewQuestionButton';

import ToolBar from './ToolBar';

const ChartHeader = ({ downloadButtons, pinToBoardButton }) => (
  <ToolBar>
    { pinToBoardButton }
    { downloadButtons }
    <NewQuestionButton />
    <HistoryControls />
  </ToolBar>
);

ChartHeader.propTypes = {
  downloadButtons: PropTypes.node,
  pinToBoardButton: PropTypes.node,
};

export default ChartHeader;



// WEBPACK FOOTER //
// ./app/components/Chart/ChartHeader/index.js